import BaseModel from '@/models/base';
import api, { downloadFile } from '@/api';
import joinPath from 'path.join';

const COMPARATOR_MAP = {
  Überwiesen: 0,
  '1. Lesung': 1,
  '2. Lesung': 2,
  '3. Lesung': 3,
  Beschluss: 4,
};

export default class JournalEntry extends BaseModel {
  static entity = 'journal_entries';
  static apiPath = 'journal_entries';

  static fields() {
    return {
      id: this.attr(null),
      date: this.date(new Date().toISOString().substr(0, 10)),
      state_of_procedure: this.string('Überwiesen'),
      comment: this.string(''),
      business_id: this.number(null),
      business: this.belongsTo('businesses', 'business_id'),
      created: this.attr(null),
      modified: this.attr(null),
      is_published: this.boolean(false),
      files: this.attr([]),
    };
  }

  static get stateOfProcedures() {
    return [
      'Überwiesen',
      '1. Lesung',
      '2. Lesung',
      '3. Lesung',
      'Beschluss',
    ];
  }

  get relevance() {
    return COMPARATOR_MAP[this.state_of_procedure];
  }

  get shortStateOfProcedure() {
    return this.state_of_procedure.substr(0, 1);
  }

  async downloadZip() {
    const { data } = await api.get(
      joinPath(this.apiPath, 'download-zip'),
      { responseType: 'blob' },
    );
    downloadFile(data, `${this.state_of_procedure}.zip`);
  }
}
